<template>
    <div>
        <footer class="footer-wrap">
            <div class="footer-content">
                <div class="f-item f-home" :class="footerSelect=='index'?'f-home-on':''" @click="goIndex">主页</div>
                <div class="f-item f-cart analysis" data-analysis="底部入口_购物车" @click="showCartBox">购物袋<em>{{cartCount}}</em></div>
                <div class="f-item f-personal" :class="footerSelect=='personal'?'f-personal-on':''" @click="goPersonal">个人中心</div>
            </div>
        </footer>

        <cartBox :showCart="showCart" @closeB="closeBox"></cartBox>
    </div>

</template>

<script>
    import cartBox from '@/components/cart-box/cart-box'
    import {sa} from '@/resource/js/ANALYSIS2'
    export default {
        name: "footerHtml",
        data() {
            return {
                showCart:false
            };
        },
        props:['footerSelect'],
        components:{
            cartBox
        },
        computed:{
            cartCount(){
                return this.$store.state.cartNew.cartTotalCount
            }
        },
        mounted() {

        },
        methods: {
            goIndex: function () {
                sa.track('lcweb',{'lcclick':'底部入口_主页'});
                window.location.href = "/";
            },
            goPersonal: function () {
                sa.track('lcweb',{'lcclick':'底部入口_个人中心'});
                window.location.href = "/pages/personal_center/personal_center.html";
            },
            showCartBox(){
                this.$store.dispatch('initCartDataInfo',{
                    "areaId": '',
                    "address": '',
                    "needLogin":0,
                    "isQuick":false
                })
                this.showCart = true;
            },
            closeBox(val){
                this.showCart = val;
            }
        }
    };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    $rem: 0.01rem;
    .footer-wrap {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background: #fafafa;
        border-top: 1px solid #edebeb;
        height: 114*$rem;
        padding-bottom: 3*$rem;
        .footer-content{
            width: 100%;
            display: flex;
            justify-content: space-between;
            position: relative;
            &:before{
                content: '';
                position: absolute;
                top:-34*$rem;
                left: 50%;
                width: 150*$rem;
                height: 150*$rem;
                margin-left: -75*$rem;
                background: url(./images/f-cart.png) top center no-repeat;
                background-size: cover;
                z-index: -1;
            }
            .f-item{
                width: 33%;
                flex: 1;
                text-align: center;
                font-size: 18*$rem;
                padding-top: 82*$rem;
                color: #101010;
            }
            .f-home{
                background: url(./images/f-home.png) center center no-repeat;
                background-size: 52*$rem 52*$rem;
                background-position: center 26*$rem;
            }
            .f-home-on{
                background: url(./images/f-home-on.png) center center no-repeat;
                background-size: 52*$rem 52*$rem;
                background-position: center 26*$rem;
                color: #e50011;
            }
            .f-personal{
                background: url(./images/f-my.png) center center no-repeat;
                background-size: 52*$rem 52*$rem;
                background-position: center 26*$rem;
            }
            .f-personal-on{
                background: url(./images/f-my-on.png) center center no-repeat;
                background-size: 52*$rem 52*$rem;
                background-position: center 26*$rem;
                color: #e50011;
            }
            .f-cart{
                position: relative;
                padding-top: 56*$rem;
                em{
                    position: absolute;
                    font-size: 18*$rem;
                    color: #ffffff;
                    line-height: 32*$rem;
                    min-width: 20*$rem;
                    padding: 0 6*$rem;
                    text-align: center;
                    border-radius: 18*$rem;
                    top: -15%;
                    left: 63%;
                    background: #e50011;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/footer/footerHtml.vue